// extracted by mini-css-extract-plugin
export default {"selected":"ListingCardNew_selected__dMQ5h","selectedAnimation":"ListingCardNew_selectedAnimation__DFbor"};